import { useState, useEffect } from "react";
import "./modal.css";
import { Calendar } from "primereact/calendar";
import { useBookSession } from "../../APIContext/BookSessionContext";

const EventFilterModal = ({ filterData, setFilterData, onClose, onApply }) => {
  const DEFAULT_FILTER = {
    location: "",
    date: null,
    start_time: null,
    end_time: null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  const { fetchLocationData } = useBookSession();
  const [locationData, setLocationData] = useState([]);
  const time_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // const [formData, setFormData] = useState({
  //   location: "",
  //   date: "",
  //   start_time: "",
  //   end_time: "",
  //   timezone: time_Zone,
  // });

  console.log(filterData.start_time);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchLocationData();
      // setLocationData((data || []).filter(i => i.company !== 1));
      setLocationData(data || []);
    };

    fetchData();
  }, []);

  const handleDateChange = (e) => {
    setFilterData((prev) => ({
      ...prev,
      date: e.value,
    }));
  };

  const handleTimeChange = (e, field) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const handleChange = (e) => {
    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };

  const formatDate = (value) => {
    if (!value) return null;

    // If already a Date
    if (value instanceof Date) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    // If already a string in YYYY-MM-DD format
    if (typeof value === "string") {
      return value; // already formatted
    }

    return null;
  };

  const formatTime = (value) => {
    if (!value) return null;

    // If already a Date
    if (value instanceof Date) {
      return value.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    }

    // If already a string like "HH:mm"
    if (typeof value === "string") {
      return value; // already formatted
    }

    return null;
  };

  const toLocalDate = (value) => {
    if (!value) return null;

    // Already a Date → return as is
    if (value instanceof Date) {
      return value;
    }

    // String → "YYYY-MM-DD"
    if (typeof value === "string") {
      const [year, month, day] = value.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    // Fallback (unexpected type)
    return null;
  };

  const timeStringToLocalDate = (timeStr) => {
    if (!timeStr) return null;

    // If already a Date, return as-is
    if (timeStr instanceof Date) {
      return timeStr;
    }

    // Expecting "HH:mm"
    if (typeof timeStr === "string") {
      const [hours, minutes] = timeStr.split(":").map(Number);

      const now = new Date(); // today, local timezone
      now.setHours(hours, minutes, 0, 0);

      return now;
    }

    return null;
  };

  const handleSubmit = () => {
    const rawData = {
      location: filterData.location ? Number(filterData.location) : null,
      date: formatDate(filterData.date),
      start_time: formatTime(filterData.start_time),
      end_time: formatTime(filterData.end_time),
      timezone: filterData.timezone,
    };

    // ✅ Remove null or empty values
    const cleanedData = Object.fromEntries(
      Object.entries(rawData).filter(
        ([_, value]) => value !== null && value !== "",
      ),
    );

    console.log("Filter Data =>", cleanedData);

    setFilterData((prev) => ({
      ...prev,
      ...cleanedData,
    }));

    // onApply && onApply(cleanedData);
    // onClose();

    onApply();
    onClose();
  };

  const handleClear = () => {
    setFilterData(DEFAULT_FILTER);
    onApply({}); // optional: immediately refetch unfiltered events
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        style={{ filter: "brightness(1.22)" }}
        className="modal-box bg-custom"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className="text-clip">Apply Your Filter Here</h3>
        </div>

        <div className="modal-content">
          {/* ✅ LOCATION */}
          <div className="modal-row">
            <label className="text-clip">Location</label>
            <select
              name="location"
              value={filterData?.location || ""}
              onChange={handleChange}
              className="select-input"
            >
              <option value="">Select location</option>
              {locationData?.map((i) => (
                <option key={i.id} value={i.id}>
                  {i.name}
                </option>
              ))}
            </select>
          </div>

          {/* ✅ DATE */}
          <div className="modal-row">
            <label className="text-clip">Date</label>
            <Calendar
              placeholder="Select Date"
              value={toLocalDate(filterData.date) || null}
              onChange={handleDateChange}
              showIcon
              dateFormat="mm-dd-yy"
              className="calesndr-cstm"
            />
          </div>

          {/* ✅ START TIME */}
          <div className="modal-row">
            <label className="text-clip">Start Time</label>
            <Calendar
              value={timeStringToLocalDate(filterData.start_time) || null}
              onChange={(e) => handleTimeChange(e, "start_time")}
              timeOnly
              hourFormat="12" // ✅ User sees AM / PM
              placeholder="Start Time"
              className="calesndr-cstm"
            />
          </div>

          {/* ✅ END TIME */}
          <div className="modal-row">
            <label className="text-clip">End Time</label>
            <Calendar
              value={timeStringToLocalDate(filterData.end_time) || null}
              onChange={(e) => handleTimeChange(e, "end_time")}
              timeOnly
              hourFormat="12" // ✅ User sees AM / PM
              placeholder="End Time"
              className="calesndr-cstm"
            />
          </div>
        </div>

        {/* ✅ ACTIONS */}
        <div className="modal-actions">
          <button onClick={handleClear} className="cancel-btn">
            Clear Filter
          </button>
          <button onClick={handleSubmit} className="save-btn">
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventFilterModal;
